module.exports = __webpack_public_path__ + "img/Noimage.981f4a2e.png";